// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  .user_layout_container {
    width: 92%;
    height: 80px;
  }
  .user_layout_header {
    height: 80px !important;
  }
  .user_layout_logo_container {
    width: 200px;
  }

  .user_layout_search_container {
    width: calc(100% - 750px);
  }

  .user_layout_menu_container {
    width: 500px;
  }

  .user_layout_drawer_container {
    justify-content: flex-end !important;
    width: 50px;
  }

  .mobile_screen {
    display: none !important;
  }
  .user_layout_logo {
    width: 200px !important;
    height: 50px;
  }
  .user_layout_menus {
    font-size: 18px;
  }

  .user_layout_search_input {
    height: 35px;
  }

  .drawer_menu_icon {
    width: 25px !important ;
    height: 25px !important;
  }
  .search_mobile_icon_container {
    display: none !important;
  }
  .drawer_menu_container {
    height: 350px;
    width: 100%;
  }

  .drawer_user_detail_container {
    height: 40px;
    justify-content: flex-end;
  }
  .drawer_user_pic {
    height: 10px;
    width: 10px;
    border-radius: 50% !important;
  }

  .header_drawer_social_media_container {
    height: 60px;
  }
  .header_drawer_social_media_wrapper {
    width: 60%;
    height: 60px;
  }
  .header_drawer_social_small_wrapper {
    width: 24%;
    height: 60px;
  }
  .header_search_icon {
    font-size: 20px;
  }
  .drawer_user_name_text {
    font-size: 18px;
  }
  .footer_mobile_view_container {
    display: none !important;
  }
  .mobile_header_drawer_theme {
    display: none !important;
  }
  .main_header {
    font-size: 13px !important;
  }
  .social_media_tag {
    font-size: 13px !important;
  }
  .quick_access_label {
    font-size: 13px !important;
  }
  .user_layout_mobile_view_search {
    display: none;
  }
  .User_login_button {
    width: 60px;
    height: 30px;
    font-size: 10px;
    display: flex;
    justify-content: center !important;
    align-items: center !important;
  }
  .quick_access_wrapper {
    width: 92% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_1024_1439/screen_1024_1439_layout.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kCAAkC;IAClC,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n  .user_layout_container {\n    width: 92%;\n    height: 80px;\n  }\n  .user_layout_header {\n    height: 80px !important;\n  }\n  .user_layout_logo_container {\n    width: 200px;\n  }\n\n  .user_layout_search_container {\n    width: calc(100% - 750px);\n  }\n\n  .user_layout_menu_container {\n    width: 500px;\n  }\n\n  .user_layout_drawer_container {\n    justify-content: flex-end !important;\n    width: 50px;\n  }\n\n  .mobile_screen {\n    display: none !important;\n  }\n  .user_layout_logo {\n    width: 200px !important;\n    height: 50px;\n  }\n  .user_layout_menus {\n    font-size: 18px;\n  }\n\n  .user_layout_search_input {\n    height: 35px;\n  }\n\n  .drawer_menu_icon {\n    width: 25px !important ;\n    height: 25px !important;\n  }\n  .search_mobile_icon_container {\n    display: none !important;\n  }\n  .drawer_menu_container {\n    height: 350px;\n    width: 100%;\n  }\n\n  .drawer_user_detail_container {\n    height: 40px;\n    justify-content: flex-end;\n  }\n  .drawer_user_pic {\n    height: 10px;\n    width: 10px;\n    border-radius: 50% !important;\n  }\n\n  .header_drawer_social_media_container {\n    height: 60px;\n  }\n  .header_drawer_social_media_wrapper {\n    width: 60%;\n    height: 60px;\n  }\n  .header_drawer_social_small_wrapper {\n    width: 24%;\n    height: 60px;\n  }\n  .header_search_icon {\n    font-size: 20px;\n  }\n  .drawer_user_name_text {\n    font-size: 18px;\n  }\n  .footer_mobile_view_container {\n    display: none !important;\n  }\n  .mobile_header_drawer_theme {\n    display: none !important;\n  }\n  .main_header {\n    font-size: 13px !important;\n  }\n  .social_media_tag {\n    font-size: 13px !important;\n  }\n  .quick_access_label {\n    font-size: 13px !important;\n  }\n  .user_layout_mobile_view_search {\n    display: none;\n  }\n  .User_login_button {\n    width: 60px;\n    height: 30px;\n    font-size: 10px;\n    display: flex;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n  .quick_access_wrapper {\n    width: 92% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
